<template>
  <v-row
    no-gutters
    wrap
    mx-2
    mb-3>
    <!-- Title -->
    <v-col
      :class="!isEmbedded ? '' : 'mb-4'"
      cols="12"
      sm="12">

      <v-col
        :class="!isEmbedded ? '' : 'pa-0'"
        cols="12">
        <h1
          :class="!isEmbedded ? 'display-1 black--text text-center font-weight-medium mb-1' : 'black--text text-center font-weight-medium headline mb-0'">
          {{ $t('validationForm.confirmDetails') }}
        </h1>
        <div
          :class="!isEmbedded ? 'body-1 text-center grey--text text--darken-3 my-4' : 'body-2 mt-2 text-center grey--text darken-2'"
          cols="12">
          {{ $t('validationForm.checkInformation') }}</div>
      </v-col>

    </v-col>
    <!-- Meeting info and Stepper -->
    <v-col
      cols="12">
      <v-row
        :class="isEmbedded ? '' : 'validationForm-info border--radius-box'"
        no-gutters>
        <!-- Meeting Host and Main info -->
        <v-col
          :class="isEmbedded ? 'blue lighten-5 mb-3 pb-2' : ''"
          cols="12"
        >
          <meeting-header-info
            :location="location"
            :duration="selectedMeetingType.duration"
            :host-picture="selectedMeetingType.pictureUrl"
            :host-name="fullName(selectedMeetingType.firstName, selectedMeetingType.lastName)"
            :is-embedded="isEmbedded"/>
          <v-divider v-if="!isEmbedded"/>
        </v-col>

        <v-col
          :class="isEmbedded ? '' : 'validationForm-info__stepper'"
          cols="12"
          md="8"
          xs="12">

          <v-col
            :class="isEmbedded ? 'px-7 pb-0' : 'px-7 pb-7 pt-0'"
            cols="12">
            <v-stepper
              :class="!isEmbedded ? 'pl-0 pb-3 ma-0 pt-0 mt-0' : 'pb-3'"
              class="form-stepper elevation-0"
              vertical>
              <v-stepper-step
                :class="!isEmbedded ? '' : 'pa-2'"
                complete
                complete-icon="check"
                step="">
                <div><span class="font-weight-medium subtitle-1">
                  {{ formatHour(meetingStartDate.tz(selectedMeetingType.timezone), selectedMeetingType.timezone) + ' - ' + formatHour(meetingEndDate.tz(selectedMeetingType.timezone), selectedMeetingType.timezone, true) + ', ' + meetingStartDate.tz(selectedMeetingType.timezone).format('MMMM D') }}<sup>{{ getNth(meetingStartDate.tz(selectedMeetingType.timezone).format('D')) }}</sup>
                  {{ meetingStartDate.tz(selectedMeetingType.timezone).format(' YYYY') }}
                </span>
                  <span class="body-2 grey--text text--darken-2">
                    {{ '(' + selectedMeetingType.timezone + ')' }}</span>
                </div>
                <div>
                  <span
                    v-if ="differentTimezone"
                    class="body-2 grey--text text--darken-2">
                    {{ formatHour(meetingStartDate.tz(selectedMeetingType.originalTimezone), selectedMeetingType.originalTimezone) + ' - ' + formatHour(meetingEndDate.tz(selectedMeetingType.originalTimezone), selectedMeetingType.originalTimezone, true) + ', ' + meetingStartDate.tz(selectedMeetingType.originalTimezone).format('MMMM D') }}<sup>{{ getNth(meetingStartDate.tz(selectedMeetingType.originalTimezone).format('D')) }}</sup>
                    {{ meetingStartDate.tz(selectedMeetingType.originalTimezone).format(' YYYY') }}
                    {{ '(' + selectedMeetingType.originalTimezone + ')' }}</span>
                </div>
              </v-stepper-step>
              <v-stepper-content
                v-if="!isEmbedded"
                step="2"/>
              <v-stepper-step
                :class="!isEmbedded ? '' : 'pa-2'"
                :complete="canBookMeeting"
                complete-icon="check"
                step="">{{ $t('validationForm.fillInformation') }}</v-stepper-step>
            </v-stepper>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent
              @keyup.enter.native="validateForm">
              <v-row
                no-gutters
                wrap>
                <v-col
                  cols="12"
                  class="mb-1">
                  <v-label
                  >Your email address</v-label>
                </v-col>
                <v-col
                  cols="12">

                  <v-text-field
                    v-model="emailAnswer"
                    :placeholder="'john@acme.com'"
                    :rules="emailRules"
                    outlined
                    autofocus
                    @input="checkRequired"/>

                </v-col>
                <template
                  v-for="(question, questionIndex) in meetingQuestions"
                >
                  <v-col
                    :key="questionIndex"
                    cols="12"
                  >
                    <v-row
                      v-if="question.questionType === 'TEXT'"
                      no-gutters
                      wrap>
                      <v-col
                        cols="12"
                        class="mb-1">
                        <v-label
                        >{{ question.required ? question.question : question.question + '' }}</v-label>
                      </v-col>
                      <v-col
                        cols="12">
                        <v-text-field
                          v-model="questionsMap[question.questionId]"
                          :placeholder="$t('validationForm.textField')"
                          :rules="question.required ? [...requiredRule, ...lengthRule] : lengthRule"
                          outlined
                          @input="checkRequired"/>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="question.questionType === 'PHONE_NUMBER'"
                      no-gutters
                      wrap>
                      <v-col
                        cols="12"
                        class="mb-1">
                        <v-label
                        >{{ question.required ? question.question : question.question + '' }}</v-label>
                      </v-col>
                      <v-col
                        cols="12">
                        <v-text-field
                          v-model="questionsMap[question.questionId]"
                          :placeholder="$t('validationForm.phoneField')"
                          :rules="question.required ? [...requiredRule, ...phoneRule] : phoneRule"
                          :maxlength="15"
                          class="phoneTextField"
                          outlined
                          @keypress="restrictInput($event, question.questionId)"
                          @input="checkRequired">
                          <template v-slot:prepend>
                            <vue-tel-input
                              @country-changed="phoneCountryChanged($event, question.questionId)">
                              <template v-slot:arrow-icon>
                                <strong>+{{ phonePrefix[question.questionId] }}</strong>
                              </template>
                            </vue-tel-input>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
            </v-form>
          </v-col>
        </v-col>
        <v-col
          :class="isEmbedded ? 'px-3 py-0' : 'px-7'"
          cols="12"
          md="4"
          sm="12"
          min-height="100%"

        >
          <v-row
            :class="isEmbedded ? '' : 'pb-12'"
            no-gutters
            align="end"
            style="height: 100%;">
            <v-col
              cols="12"
              sm="10"
            >
              <v-btn
                block
                color="grey lighten-3"
                depressed
                class="my-2"
                @click.native="$emit('cancel')">
                <v-icon
                  left
                  small>arrow_back</v-icon>
                {{ $t('validationForm.goBack') }}
              </v-btn>
              <v-btn
                :disabled="!canBookMeeting"
                :loading="isSaving"
                :class="isEmbedded ? 'mt-4 mb-12' : 'my-2'"
                class="primary"
                block
                x-large
                color="white"
                @click.native="validateForm">{{ $t('validationForm.confirm') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { userMixin, localeMixin, snackbarMixin } from '../mixins'
import { mapGetters } from 'vuex'
import { nth } from '../modules/utils'
import moment from 'moment'
import { VueTelInput } from 'vue-tel-input'
import MeetingHeaderInfo from './MeetingHeaderInfo.vue'

export default {
  components: {
    MeetingHeaderInfo,
    VueTelInput
  },
  mixins: [userMixin, localeMixin, snackbarMixin],
  props: {
    startTimestamp: {
      type: String,
      required: true
    },
    endTimestamp: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    isEmbedded: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      canBookMeeting: false,
      emailAnswer: '',
      nativeTimezone: null,
      isSaving: false,
      phonePrefix: [],
      questionsMap: [],
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      emailRules: [
        v => !!v || this.$t('validationForm.required'),
        v => {
          return !v || this.emailRegex.test(v) || this.$t('validationForm.invalidEmail')
        }
      ],
      requiredRule: [
        v => !!v || this.$t('validationForm.required')
      ],
      lengthRule: [
        v => (!v || v.length === 0 || (v && v.length <= 1000)) || this.$t('validationForm.answerTooLong')
      ],
      phoneRule: [
        v => (!v || v.length === 0 || (v.length <= 15 && v.length >= 8)) || this.$t('validationForm.invalidPhone')
      ]

    }
  },
  computed: {
    ...mapGetters('meetings', [
      'selectedMeetingTypeId',
      'selectedMeetingType',
      'meetingQuestions'
    ]),
    meetingStartDate () {
      return moment.unix(this.startTimestamp)
    },
    meetingEndDate () {
      return moment.unix(this.endTimestamp)
    },
    differentTimezone () {
      if (this.nativeTimezone && this.nativeTimezone === this.selectedMeetingType.timezone) {
        return this.meetingStartDate.tz(this.selectedMeetingType.originalTimezone).format() !== this.meetingStartDate.tz(this.nativeTimezone).format()
      }
    }
  },
  mounted () {
    this.questionsMap = []
    this.emailAnswer = this.email
    this.nativeTimezone = moment.tz.guess()
    this.$nextTick(() => {
      this.checkRequired()
    })
  },
  methods: {
    async validateForm () {
      if (this.$refs.form.validate()) {
        this.isSaving = true
        try {
          let answers = []
          this.meetingQuestions.forEach(question => {
            if (question.questionType === 'PHONE_NUMBER') {
              var answer = ''
              if (this.questionsMap[question.questionId] && this.questionsMap[question.questionId].length > 0) {
                answer = '(+' + this.phonePrefix[question.questionId] + ') ' + this.questionsMap[question.questionId]
              }
              answers.push({ questionIdEnc: question.questionId, answer })
            } else {
              answers.push({ questionIdEnc: question.questionId, answer: (this.questionsMap[question.questionId] || '') })
            }
          })
          const payload = { meetingTypeId: this.selectedMeetingTypeId,
            startTimestamp: this.startTimestamp,
            endTimestamp: this.endTimestamp,
            inviteeEmail: this.emailAnswer,
            timezone: this.selectedMeetingType.timezone,
            answers }
          await this.$store.dispatch('meetings/createMeeting', payload)
          this.$emit('booked')
        } catch (err) {
          console.log(err)
          this.openSnackbarError()
        }
        this.isSaving = false
      }
    },
    checkRequired () {
      if (this.emailAnswer.length === 0 || !this.emailRegex.test(this.emailAnswer)) {
        this.canBookMeeting = false
        return
      }
      let requiredFilled = true
      this.meetingQuestions.forEach(question => {
        if (question.required && (!this.questionsMap[question.questionId] || this.questionsMap[question.questionId].length === 0)) {
          requiredFilled = false
        }
      })
      if (requiredFilled) {
        this.canBookMeeting = this.$refs.form.validate()
      }
    },
    getNth (date) {
      return nth(date)
    },
    phoneCountryChanged (event, questionId) {
      this.phonePrefix[questionId] = event.dialCode
    },
    restrictInput (event, questionId) {
      if (!/\d/.test(event.key) && event.key !== ' ' && event.key !== '-') {
        return event.preventDefault()
      }
      if (this.questionsMap[questionId] && (event.key === ' ' || event.key === '-')) {
        const lastChar = this.questionsMap[questionId].slice(-1)
        if (lastChar === ' ' || lastChar === '-') {
          return event.preventDefault()
        }
      }
    }
  }

}
</script>
<style lang="scss">
.form-stepper {
  box-shadow: none;
}
.phoneTextField {
  .v-input__prepend-outer {
    margin-top: 0px;
  }
  .vue-tel-input{
    width: 85px;
    height: 56px;
    .vti__dropdown {
      width: 85px;
    }
    .vti__input {
      display: none;
    }
    .vti__dropdown-list.below {
      top: 54px;
    }
  }
}
.validationForm-info {
  border: 1px solid #dedede;
  &__stepper {
    overflow-y: scroll;
    max-height: 66vh;
  }
}
</style>
